import {  Edit, Trash2 } from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { all_routes } from "../../../Router/all_routes";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";
import { Box } from "@mui/material";
import "sweetalert2/dist/sweetalert2.min.css";
import HeaderModule from "../../components/Header/HeaderModule";
import { useCheckUserPermission } from "../../common/userPermission";

const roleMasterDelete = "RoleMasterDelete";

const RoleMastersList = () => {
  const navigate = useNavigate();
  const [productlist, setProductlist] = useState([]);
  const [deletes, setdelete] = useState(false);
  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (id) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        // showLoadingAlert(); // Show loader while deleting
        handleDelete(id);
      }
    });
  };

  // const showLoadingAlert = () => {
  //   MySwal.fire({
  //     title: "Deleting...",
  //     text: "Please wait while we process your request.",
  //     allowOutsideClick: false,
  //     didOpen: () => {
  //       MySwal.showLoading(); // Show loading spinner
  //     },
  //   });
  // };

  const handleDelete = async (id) => {
    let reqobj = {
      ID: id,
      Module: "roleMaster",
    };

    try {
      const response = await apiHandler({
        method: "POST",
        route: "Superadmin/deletebymoduleid",
        payload: reqobj,
      });

      if (response.ResponseCode === "SUCCESS") {
        MySwal.fire({
          title: "Deleted!",
          text: "Your role master has been deleted.",
          icon: "success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        setdelete(!deletes);
      } else {
        MySwal.fire({
          title: "Error!",
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      MySwal.fire({
        title: "Error!",
        text: "An error occurred. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const columns = [
    {
      header: "ID",
      accessorKey: "id",
      enableSorting: true,
      sortingFn: "numeric",
    },
    {
      header: "Name",
      accessorKey: "roleName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Description",
      accessorKey: "roleDescription",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "For Business Admin",
      accessorKey: "businessAdmin",
      enableSorting: true,
      Cell: ({ row }) => {
        return <div>{row.original.businessAdmin == 1 ? "YES" : "No"}</div>;
      },
      sortingFn: "number",
    },
    {
      accessorKey: "actions",
      header: "Actions",
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: "0.5rem" }}>
          {useCheckUserPermission(route.RoleMaster) && (
            <button
             className="btn btn-outline-primary btn-sm me-2"
              // color="primary"
              onClick={() => {
                navigate(`${route.RoleMaster}/${row.original.id}`);
              }}
            >
              <Edit className='custome-icon-size' />
            </button>
          )}
          {useCheckUserPermission(roleMasterDelete) && (
            <button
             className="btn btn-outline-primary btn-sm me-2"
              // color="error"
              onClick={() => {
                showConfirmationAlert(row.original.id);
              }}
            >
              <Trash2 className='custome-icon-size' />
            </button>
          )}
        </Box>
      ),
    },
  ];

  const route = all_routes;

  const prodcutDataListApi = async () => {
    const response = await apiHandler({
      method: "GET",
      route: `Superadmin/roleMasterAll`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setProductlist(response.ResponseData);
    } else {
      console.log(response, "data");
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, [deletes]);

  const exportData = productlist.map((item) => ({
    ID: item?.id,
    Name: item?.roleName,
    Description: item?.roleDescription,
    ForBusinessAdmin: item?.businessAdmin == 1 ? "YES" : "NO",
  }));

  return (
    <div className="page-wrapper">
      <div className="content">
        <HeaderModule
          refreshData={prodcutDataListApi}
          exportData={exportData}
          addMasterPageLink={route.RoleMaster}
        />
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <CommonMaterialReactTable columns={columns} data={productlist} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleMastersList;
